import * as proceduralTextures from "@lts/procedural-textures/legacy/legacy";
export { proceduralTextures };
export default proceduralTextures;
